import { render, staticRenderFns } from "./VisitPointEditTabAccount.vue?vue&type=template&id=35497948&scoped=true&"
import script from "./VisitPointEditTabAccount.vue?vue&type=script&lang=js&"
export * from "./VisitPointEditTabAccount.vue?vue&type=script&lang=js&"
import style0 from "./VisitPointEditTabAccount.vue?vue&type=style&index=0&id=35497948&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35497948",
  null
  
)

export default component.exports